export const initialState = {
  loadingStatus: {
    loadPractitionersLoading: false,
    loadBookingSlotLoading: false,
  },
  practitioners: [],
  bookingSlots: [],
  currentStep: 1,
  previousStep: [],
  isFromExternalSource: false,
  bookingSlotHolding: {},
  isHoldingCreateBooking: false,
  appointmentCreated: {},
};
